module.exports = __webpack_public_path__ + "img/addshipping.2a6881c9.png";